<template>
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <h4 class="mt-2 text-center text-bold">
      ສາທາລະນະລັດ ປະຊາທິປະໄຕ ປະຊາຊົນລາວ
    </h4>
    <h4 class="mt-2 text-center text-bold">
      ສັນຕິພາບ ເອກະລາດ ປະຊາທິປະໄຕ ເອກະພາບ ວັດທະນາຖາວອນ
    </h4>
    <br />
    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-5"></div>
          <div class="col-md-2">
            <h1 class="text-center" style="color: #54c392"><b>Daily</b></h1>
            <br /><br />
            <!-- <img src="image/logo.jpg" alt="Logo" class="w-50 h-100 rounded-circle">   -->
          </div>
          <div class="col-md-5"></div>
        </div>
        <div class="row">
          <div class="col-md-2"></div>
          <div class="col-md-2">
            <h5 class="text-bold">ຊື່ຜູ້ດູແລ: ແອັດມິນ</h5>
          </div>
          <div class="col-md-4">
            <h2 class="text-center text-bold" style="color: #54c392">
              ໃບບິນລາຍຈ່າຍ
            </h2>
          </div>
          <div class="col-md-3">
            <h6 class="text-bold" id="datetime">
              <date-time-component></date-time-component>
            </h6>
          </div>
        </div>
        <br />
        <div class="row">
          <!-- left column -->
          <div class="col-md-1"></div>
          <!--/.col (left) -->
          <!-- right column -->
          <div class="col-md-10" style="overflow: auto">
            <div class="d-flex justify-content-between">
              <div></div>
              <div class="d-flex">
                <div class="mx-1">
                  <button
                    class="btn text-white mb-2"
                    style="background-color: #54c392"
                    @click="exportToPdf"
                  >
                    <i class="fas fa-arrow-circle-down mx-1"></i>
                    ດາວໂຫຼດ PDF
                  </button>
                </div>

                <div>
                  <button class="btn btn-success mb-2" @click="exportToExcel">
                    <i class="fas fa-arrow-circle-down mx-1"></i>
                    ດາວໂຫຼດ Excel
                  </button>
                </div>
              </div>
            </div>
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>#</th>
                  <th>ຈຳນວນເງິນ</th>
                  <th>ລາຍລະອຽດ</th>
                  <th>ສະຖານະ</th>
                  <th>ວັນທີ່ເວລາ</th>
                </tr>
              </thead>
              <template
                v-for="(yearExpenditures, year) in groupedExpenditures"
                :key="year"
              >
                <!-- Year Row -->
                <tr>
                  <td colspan="5" class="text-center bg-light">
                    <b>ລາຍຈ່າຍປີ {{ year }}</b>
                  </td>

                  <td colspan="1" class="bg-light text-center">
                    <!-- PLUS -->
                    <span
                      v-if="!expandedYears[year]"
                      class="text-bold mx-2"
                      style="cursor: pointer"
                      @click="toggleYear(year)"
                    >
                      <i class="fas fa-plus"></i>
                    </span>

                    <!-- MINUS -->
                    <span
                      v-else
                      class="text-bold mx-2"
                      style="cursor: pointer"
                      @click="toggleYear(year)"
                    >
                      <i class="fas fa-minus"></i>
                    </span>
                  </td>
                </tr>
                <tr
                  v-show="expandedYears[year]"
                  v-for="(expenditure_data, index) in yearExpenditures"
                  :key="expenditure_data.id"
                >
                  <td>{{ index + 1 }}</td>
                  <td>
                    <b class="text-danger">{{
                      formatNumber(expenditure_data.expenditure)
                    }}</b>
                  </td>
                  <td>
                    <b>{{ expenditure_data.expenditure_reason }}</b>
                  </td>
                  <td>
                    <b class="text-danger">{{ expenditure_data.m_status }}</b>
                  </td>
                  <td>
                    <b class="text-success">{{ expenditure_data.timestamp }}</b>
                  </td>
                </tr>
              </template>
              <tbody>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class="text-bold">ລວມທັງໝົດ:</td>
                  <td class="text-bold text-danger">
                    {{ formatNumber(sum_expenditures) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--/.col (right) -->

          <div class="col-md-1"></div>
        </div>

        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </section>
    <!-- /.content -->
  </div>
  <br />
  <div class="row">
    <div class="col-md-5"></div>
    <div class="col-md-2">
      <h1 class="text-center text-bold">ຂໍຂອບໃຈ</h1>
      <!-- <img src="image/logo.jpg" alt="Logo" class="w-50 h-100 rounded-circle">   -->
    </div>
    <div class="col-md-5"></div>
  </div>
  <br /><br />
</template>
<script>
import axios from "axios";
import DateTimeComponent from "./DateTimeComponent.vue";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "PrintExpenditureComponent",
  components: {
    DateTimeComponent,
  },
  watch: {
    groupedExpenditures: {
      immediate: true,
      handler(val) {
        const years = Object.keys(val);
        if (years.length) {
          this.expandedYears[years[0]] = true;
        }
      },
    },
  },
  computed: {
    groupedExpenditures() {
      return this.expenditure_datas.reduce((group, expenditure_datas) => {
        const year = new Date(expenditure_datas.timestamp).getFullYear();

        if (!group[year]) {
          group[year] = [];
        }

        group[year].push(expenditure_datas);
        return group;
      }, {});
    },
  },
  data() {
    return {
      expenditure_datas: [],
      sum_expenditures: 0,
      expandedYears: {},
    };
  },
  created() {
    this.fetchExpenditure();
    this.fetchSumExpenditure();
  },
  methods: {
    toggleYear(year) {
      this.expandedYears[year] = !this.expandedYears[year];
    },
    formatNumber(value) {
      if (!value) return "0";
      return Number(value).toLocaleString("en-US");
    },
    exportToExcel() {
      // Prepare data for Excel
      const dataForExcel = this.expenditure_datas.map((item, index) => ({
        "#": index + 1,
        ຈຳນວນເງິນ: item.expenditure,
        ລາຍລະອຽດ: item.expenditure_reason,
        ສະຖານະ: item.m_status,
        ວັນທີ່ເວລາ: item.timestamp,
      }));

      // Add sum row
      dataForExcel.push({
        "#": "",
        ຈຳນວນເງິນ: "",
        ລາຍລະອຽດ: "",
        ສະຖານະ: "ລວມທັງໝົດ",
        ວັນທີ່ເວລາ: this.sum_expenditures,
      });

      // Create a worksheet
      const ws = XLSX.utils.json_to_sheet(dataForExcel);

      // Create a workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Expenditure");

      // Export to file
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      saveAs(
        new Blob([wbout], { type: "application/octet-stream" }),
        "expenditure.xlsx"
      );
    },
    exportToPdf() {
      window.print();
    },
    // for Admin
    async fetchExpenditure() {
      try {
        const response = await axios.get(
          "https://nodejs-api-daily-porchoua-4.onrender.com/api/all-expenditure"
        );
        if (Array.isArray(response.data)) {
          this.expenditure_datas = response.data;
        } else {
          console.error("Invalid response format:", response.data);
          this.showErrorMessage();
        }
      } catch (error) {
        console.error("Error fetching note:", error);
        this.showErrorMessage();
      }
    },
    async createExpenditure() {
      try {
        const response = await axios.post(
          "https://nodejs-api-daily-porchoua-4.onrender.com/api/create-expenditure",
          {
            expenditure: this.expenditure,
            expenditure_reason: this.expenditure_reason,
            m_status: this.m_status,
            timestamp: this.timestamp,
          }
        );
        console.log(response.data);
        // alert('Employee added successfully');
        this.showSuccessMessage();
        // Optionally, you can fetch the updated list of sale employees after adding a new employee
        this.fetchExpenditure();
        this.resetNote_Form();
      } catch (error) {
        console.error("Error creating note:", error);
        // alert('Failed to create employee');
        this.showErrorMessage();
      }
    },
    async fetchSumExpenditure() {
      axios
        .get(
          "https://nodejs-api-daily-porchoua-4.onrender.com/api/sum-all-expenditure"
        )
        .then((response) => {
          this.sum_expenditures = response.data.sum_expenditure;
        })
        .catch((error) => {
          console.error("There was an error fetching the count:", error);
        });
    },
    // Other methods...
  },
};
</script>
